export default __webpack_public_path__ + "static/media/vid2.c9f0db79.mp4";